import { HeaderStyled2, ModalAviso } from '../styles/header';
import { IoHome, IoPersonCircle, IoExit } from 'react-icons/io5';
import { SiPivotaltracker } from 'react-icons/si';
import { FaCow } from 'react-icons/fa6';
import { TbEngine } from 'react-icons/tb';
import imgLogo from '../assets/logos/jallesNewLogo.jpg';
import { useNavigate } from 'react-router-dom';
import imgMotoBomba from '../assets/icons/motobombaWhite.png';
import imgPump from '../assets/icons/pumpWite.png';
import imgTanque from '../assets/icons/Novotanque.png';
import { RiAdminFill } from 'react-icons/ri';
import { FaCloudSun } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { HomeContext } from '../contexts/contexHome';
import { useContext } from 'react';
import { IoWarningOutline } from 'react-icons/io5';
import imgLogoACLS from '../assets/logos/novaLogoAcls.png';
import { IoCloseCircleOutline } from 'react-icons/io5';
import imgPivo from '../assets/icons/pivot2.png';
import imgAgua from '../assets/icons/aguaBranca.png';
import imgAguaSuja from '../assets/icons/aguaSujaIcon.png';
import iaAClS from '../assets/icons/ia.png';
import { apiJalles } from '../services/api';

export const Header = ({ tanque, motobomba }) => {
  const { user } = useContext(HomeContext);
  const navigate = useNavigate();
  const [openHeader, setOpenHeader] = useState(false);
  const [modalAvisoOpen, setModalAvisoOpen] = useState(false);
  const unit = sessionStorage.getItem('connectionsUnit');

  return (
    <HeaderStyled2 open={openHeader}>
      {modalAvisoOpen && (
        <ModalAviso onClick={() => setModalAvisoOpen(!modalAvisoOpen)}>
          <div
            className="conteiner"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <IoCloseCircleOutline
              className="fecharModal"
              onClick={() => setModalAvisoOpen(!modalAvisoOpen)}
            />
            <IoWarningOutline className="icon" />
            <h3>Essa Função nao esta disponivel para Essa Unidade</h3>
            <p>Entre em contato com ACLS para Ativar Essa Função Nessa Unidade</p>
            <img src={imgLogoACLS} alt="" />
          </div>
        </ModalAviso>
      )}
      <ul>
        <li
          className="logoLi"
          onClick={() => {
            // setOpenHeader(!openHeader);
            navigate('/');
          }}
        >
          <img src={imgLogo} alt="" />
        </li>
        <li
          onClick={() => {
            navigate('/');
          }}
        >
          <IoHome className="iconHome" />
          <span>Home</span>
        </li>
        <li
          className={`iconImgs ${!tanque && 'disabled'}`}
          onClick={() => navigate(`/${unit}/tanques`)}
        >
          <img src={imgTanque} alt="" />
          <span>Tanques</span>
        </li>
        <li
          className={`iconImgs ${!motobomba && 'disabled'}`}
          onClick={() => {
            if (motobomba) {
              navigate(`/${unit}/Motobomba`);
            } else {
              setModalAvisoOpen(true);
            }
          }}
        >
          <img src={imgMotoBomba} alt="" />
          <span>MotoBomba</span>
        </li>
        <li className="iconImgs disabled" onClick={() => setModalAvisoOpen(true)}>
          <img src={imgPump} alt="" />
          <span>EletroBombas</span>
        </li>
        <li className="disabled" onClick={() => setModalAvisoOpen(true)}>
          <SiPivotaltracker />
          <span>Pivô</span>
        </li>
        <li className="disabled" onClick={() => setModalAvisoOpen(true)}>
          <FaCloudSun />
          <span>Estações Meteorológicas</span>
        </li>
        <li className="disabled" onClick={() => setModalAvisoOpen(true)}>
          <FaCow />
        </li>
        <li className="disabled" onClick={() => setModalAvisoOpen(true)}>
          <TbEngine />
        </li>
      </ul>
      <div className="sectionBottom">
        {user.is_superuser ? (
          <div className="admin">
            <RiAdminFill
              onClick={() => {
                navigate('/admin');
                // window.location.reload();
              }}
            />
            <span>Admin</span>
          </div>
        ) : null}

        <div className="exit">
          <IoExit
            onClick={() => {
              sessionStorage.removeItem('connectionsToken');
              sessionStorage.removeItem('connectionsUnit');
              navigate('/Login');
            }}
          />
          <span>Sair</span>
        </div>
      </div>
    </HeaderStyled2>
  );
};

export const Header2 = () => {
  const { user, modalAvisoOpen, setModalAvisoOpen } = useContext(HomeContext);
  const navigate = useNavigate();

  const [loading, setloading] = useState(false);
  const [Unidades, setUnidades] = useState({});

  const unityExists = sessionStorage.getItem('connectionsUnit');
  const ListUnidade = [
    {
      titulo: 'Pivô',
      status: true,
      navigate: `/${unityExists}/Painelpivos/Map`,
      img: imgPivo,
      icon: false,
    },
    {
      titulo: 'Tanques de vinhaça',
      status: true,
      navigate: `/${unityExists}/tanques`,
      img: imgTanque,
      icon: false,
    },
    {
      titulo: 'Estações Meteorológicas',
      status: true,
      navigate: `/${unityExists}/clima`,
      img: <FaCloudSun className="icon" />,
      icon: true,
    },
    {
      titulo: 'Motobombas',
      status: false,
      navigate: `/${unityExists}/`,
      img: imgPump,
      icon: false,
    },
    {
      titulo: 'Eletrobombas',
      status: false,
      navigate: `/${unityExists}/`,
      icon: true,
      img: <TbEngine className="icon" />,
    },
    {
      titulo: 'Reservatório de Água Limpa',
      status: false,
      navigate: `/${unityExists}/`,
      img: imgAgua,
      icon: false,
    },
    {
      titulo: 'Reservatório de Água Suja',
      status: false,
      navigate: `/${unityExists}/`,
      img: imgAguaSuja,
      icon: false,
    },
    {
      titulo: 'Biodigestor',
      status: false,
      navigate: `/${unityExists}/`,
      icon: true,
      img: <FaCow className="icon" />,
    },
    {
      titulo: 'Acls IA',
      status: false,
      navigate: `/${unityExists}/AclsIA`,
      icon: false,
      img: iaAClS,
    },
  ];

  const ListUnidades = async () => {
    setloading(true);
    try {
      const token = sessionStorage.getItem('connectionsToken');
      const idUnidade = sessionStorage.getItem('connectionsUnitId');

      const headerApi = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await apiJalles.get(`unidade/Leitura/${idUnidade}`, headerApi);
      setUnidades(response.data);
      let locUnidade = {
        lat: response.data.latitude,
        long: response.data.longitude,
      };
      sessionStorage.setItem('connectionsUnitIdloc', JSON.stringify(locUnidade));
    } catch (error) {
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    ListUnidades();
  }, []);

  return (
    <HeaderStyled2>
      {modalAvisoOpen && (
        <ModalAviso onClick={() => setModalAvisoOpen(!modalAvisoOpen)}>
          <div
            className="conteiner"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <IoCloseCircleOutline
              className="fecharModal"
              onClick={() => setModalAvisoOpen(!modalAvisoOpen)}
            />
            <IoWarningOutline className="icon" />
            <h3>Este serviço não foi contratado para esta unidade.</h3>
            <p>
              Entre em contato com ACLS caso tenha interesse em <span>contratar</span> este módulo.
            </p>
            <a href="https://aclstecnologia.com/" target="_blank" rel="noopener noreferrer">
              <img src={imgLogoACLS} alt="" />
            </a>
          </div>
        </ModalAviso>
      )}

      <ul>
        <li
          className="logoLi"
          onClick={() => {
            navigate('/');
          }}
        >
          <img src={imgLogo} alt="" />
        </li>
        <li
          onClick={() => {
            navigate('/');
          }}
        >
          <IoHome className="iconHome" />
          <span>Home</span>
        </li>
        {ListUnidade.map((List, index) => {
          const aplicacaoContratada =
            Unidades && Unidades.aplicacoes && Unidades.aplicacoes[index] === true;
          return (
            aplicacaoContratada && (
              <li
                key={index}
                onClick={() => {
                  navigate(List.navigate);
                }}
              >
                {/* <SiPivotaltracker /> */}
                {List.icon ? List.img : <img src={List.img} alt="" />}
                <span>{List.titulo}</span>
              </li>
            )
          );
        })}
      </ul>
      <div className="sectionBottom">
        {user.role > 2 ? (
          <div className="admin">
            <RiAdminFill
              onClick={() => {
                navigate('/admin');
                // window.location.reload();
              }}
            />
            <span>Admin</span>
          </div>
        ) : null}

        <div className="exit">
          <IoExit
            onClick={() => {
              sessionStorage.removeItem('connectionsToken');
              sessionStorage.removeItem('connectionsUnit');
              navigate('/Login');
            }}
          />
          <span>Sair</span>
        </div>
      </div>
    </HeaderStyled2>
  );
};
